import { TipoPersonaEnum, TipoAutoconsumoEnum, EstadoOperacionEnergiaEnum, OrigenConocimientoCupsEnum } from "@api/api";
import type {
  TitularModel, DocumentosModel, FacturacionModel, SuministroModel,
  DetailOperacionEnergiaModel, EstructuraDocumentalOperacionEnergiaModel, DetailComparacionEnergiaModel, 
  DetailOperacionEnergiaInmuebleModel, TramiteGasModel, TramiteLuzModel, EditOperacionEnergiaModel
} from "@api/api";
import { TipoEnergiaSeleccionadaEnum } from "./TipoEnergiaSeleccionadaEnum";

export class OperacionEnergia implements EditOperacionEnergiaModel {

  Id: string = '';
  IdBorradorOperacion: string | null = null;
  IdEmpresaServicios: string;
  OrigenConocimientoCups: OrigenConocimientoCupsEnum | null = null;
  IdEstado: EstadoOperacionEnergiaEnum;
  IdEmpresaAgentes: string;
  CodigoEstado: string;
  Titular: TitularModel;
  Suministro: SuministroModel;
  TramiteLuz: TramiteLuz | null = null;
  TramiteGas: TramiteGas | null = null;
  Facturacion: FacturacionModel;
  Documentos: DocumentosModel[];
  EsEditable: boolean = false;
  EsEditableBo: boolean = false
  EsEnviableBo: boolean = false
  EsAceptableBo: boolean = false
  EsRechazableBo: boolean = false
  EsDeshacibleBo: boolean = false
  PuedeEnviarseFirmaManualBo: boolean = false
  PuedeFirmarseManualBo: boolean = false
  PuedeDescargarFicheroEmpresaServicios: boolean = false;
  PuedeGenerarConsentimientoPrevio: boolean = false;
  PuedeGestionarConsentimientoPrevio: boolean = false;

  //Propiedades de tramites
  TramiteLuzFechaActivacion: Date | null = null;
  TramiteLuzFechaBaja: Date | null = null;
  TramiteLuzPuedeIniciarValidacion: boolean = false;
  TramiteLuzPuedeIniciarTareas: boolean = false;
  TramiteLuzPuedeRecuperarse: boolean = false;
  TramiteLuzPuedeEnviarse: boolean = false;
  TramiteLuzPuedeRechazarsePdtGestion: boolean = false;
  TramiteLuzPuedeRechazarseReprocesable: boolean = false;
  TramiteLuzPuedeAceptarse: boolean = false;
  TramiteLuzPuedeRechazarseEnFirme: boolean = false;
  TramiteLuzPuedeCancelarse: boolean = false;
  TramiteLuzPuedeAnularse: boolean = false;
  TramiteLuzPuedeActivarse: boolean = false;
  TramiteLuzPuedeDarseBaja: boolean = false;
  TramiteGasFechaActivacion: Date | null = null;
  TramiteGasFechaBaja: Date | null = null;
  TramiteGasPuedeIniciarValidacion: boolean = false;
  TramiteGasPuedeIniciarTareas: boolean = false;
  TramiteGasPuedeRecuperarse: boolean = false;
  TramiteGasPuedeEnviarse: boolean = false;
  TramiteGasPuedeRechazarsePdtGestion: boolean = false;
  TramiteGasPuedeRechazarseReprocesable: boolean = false;
  TramiteGasPuedeAceptarse: boolean = false;
  TramiteGasPuedeRechazarseEnFirme: boolean = false;
  TramiteGasPuedeCancelarse: boolean = false;
  TramiteGasPuedeAnularse: boolean = false;
  TramiteGasPuedeActivarse: boolean = false;
  TramiteGasPuedeDarseBaja: boolean = false;

  //Propiedades extra
  private _tipoPersonaSeleccionada: TipoPersonaEnum | undefined;
  private _tipoEnergiaSeleccionada: TipoEnergiaSeleccionadaEnum | undefined;
  private _tengoLuz: boolean | undefined;
  private _tengoGas: boolean | undefined;
  private _conexionLuzActivaPasado: boolean | undefined;
  private _conexionGasActivaPasado: boolean | undefined;

  constructor() {
    this.IdEmpresaServicios = '';
    this.IdEmpresaAgentes = '';
    this.IdEstado = EstadoOperacionEnergiaEnum.PdtCompletar;
    this.CodigoEstado = '';
    this.Titular = {
      TipoPersona: TipoPersonaEnum.Fisica,
      Nombre: null,
      Apellidos: null,
      Nacionalidad: null,
      DocumentoEfectivo: null,
      Documento: null,
      Movil: null,
      Telefono: null,
      Email: null,
      RazonSocial: null,
      CIF: null,
      SubtipoPersona: null,
      IdTipoRepresentanteCcPp: null,
      NumeroColegiadoAdministradorFincas: null,
      ColegioAdministradorFincas: null,
      Direccion: {
        CodigoPostal: null,
        Provincia: null,
        Municipio: null,
        TipoVia: null,
        NombreVia: null,
        Numero: null,
        Escalera: null,
        Piso: null,
        Puerta: null
      },
      CambioTitular: false,
      DireccionIgualSuministro: true
    },
      this.Suministro = {
        Direccion: {
          CodigoPostal: null,
          Provincia: null,
          Municipio: null,
          TipoVia: null,
          NombreVia: null,
          Numero: null,
          Escalera: null,
          Piso: null,
          Puerta: null
        },
        IdCNAE: null,
        CNAE: null,
        FacturaDigital: null
      },
      this.Facturacion = {
        IBAN: null,
        TitularDistintoContrato: false,
        Nombre: null,
        Apellidos: null,
        TipoDocumento: null,
        Documento: null
      },
      this.Documentos = []
  }
  

  // Getters
  get TipoPersona(): TipoPersonaEnum | null {
    return this.Titular.TipoPersona;
  }

  get TipoPersonaSeleccionada(): TipoPersonaEnum | undefined {
    return this._tipoPersonaSeleccionada;
  }
  
  get TipoEnergiaSeleccionada(): TipoEnergiaSeleccionadaEnum | undefined {
    return this._tipoEnergiaSeleccionada;
  }

  get TengoLuz(): boolean | undefined {
    return this._tengoLuz;
  }
  
  get TengoGas(): boolean | undefined {
    return this._tengoGas;
  }

  get ConexionLuzActivaPasado(): boolean | undefined{
    return this._conexionLuzActivaPasado;
  }

  get ConexionGasActivaPasado(): boolean | undefined{
    return this._conexionGasActivaPasado;
  }

  get OfertasSeleccionadas(): string[] {
    let ofertas = [];
    if (this.TramiteLuz && this.TramiteLuz.IdOferta)
      ofertas.push(this.TramiteLuz.IdOferta);
    if (this.TramiteGas && this.TramiteGas.IdOferta)  
      ofertas.push(this.TramiteGas.IdOferta);
    return ofertas;
  }

  get ServiciosSeleccionados(): string[] {
    let servicios = [];
    if (this.TramiteLuz && this.TramiteLuz.IdsServicios)
      servicios.push(...this.TramiteLuz.IdsServicios);
    if (this.TramiteGas && this.TramiteGas.IdsServicios)  
      servicios.push(...this.TramiteGas.IdsServicios);
    return servicios;
  }

  // Setters
  set TipoPersona(value: TipoPersonaEnum) {
    if (this.Titular.TipoPersona != value){
      this._tipoEnergiaSeleccionada = undefined;
      this._tengoLuz = undefined;
      this._tengoGas = undefined;
      this._conexionLuzActivaPasado = undefined;
      this._conexionGasActivaPasado = undefined;
      this.resetTramites();
    }
    this.Titular.TipoPersona = value;
    this._tipoPersonaSeleccionada = value;
  }

  set TipoEnergiaSeleccionada(value: TipoEnergiaSeleccionadaEnum | undefined) {
    if (this._tipoEnergiaSeleccionada != value){
      this._tengoLuz = undefined;
      this._tengoGas = undefined;
      this._conexionLuzActivaPasado = undefined;
      this._conexionGasActivaPasado = undefined;
      this.resetTramites();
    }
    this._tipoEnergiaSeleccionada = value;
  }
  
  set TengoLuz(value: boolean | undefined) {
    if (this._tengoLuz != value){
      this._conexionLuzActivaPasado = undefined;
      this._conexionGasActivaPasado = undefined;
      this.resetTramites();
    }
    this._tengoLuz = value;
  }
  
  set TengoGas(value: boolean | undefined) {
    if (this._tengoGas != value){
      this._conexionLuzActivaPasado = undefined;
      this._conexionGasActivaPasado = undefined;
      this.resetTramites();
    }
    this._tengoGas = value;
  }
  
  set ConexionLuzActivaPasado(value: boolean | undefined) {
    if (this._conexionLuzActivaPasado != value){
      this.resetTramites();
    }
    this._conexionLuzActivaPasado = value;
  }

  set ConexionGasActivaPasado(value: boolean | undefined) {
    if (this._conexionGasActivaPasado != value){
      this.resetTramites();
    }
    this._conexionGasActivaPasado = value;
  }

  public generarTramite(): void {
    switch (this.TipoEnergiaSeleccionada) {
      case TipoEnergiaSeleccionadaEnum.Luz:
        this.TramiteLuz = new TramiteLuz();
        this.TramiteLuz!.Alta = !this._tengoLuz;
        this.TramiteLuz!.ConexionPrevia = this._conexionLuzActivaPasado != undefined ? this._conexionLuzActivaPasado : null;
        this.TramiteLuz!.ComercializadoraAnterior = null;
        this.TramiteGas = null;
        break;
      case TipoEnergiaSeleccionadaEnum.Gas:
        this.TramiteLuz = null;
        this.TramiteGas = new TramiteGas();
        this.TramiteGas.Alta = !this._tengoGas;
        this.TramiteGas.ConexionPrevia = this._conexionGasActivaPasado != undefined ? this._conexionGasActivaPasado : null;
        break;
      case TipoEnergiaSeleccionadaEnum.LuzYGas:
        this.TramiteLuz = new TramiteLuz();
        this.TramiteLuz.Alta = !this._tengoLuz;
        this.TramiteLuz.ConexionPrevia = this._conexionLuzActivaPasado != undefined ? this._conexionLuzActivaPasado : null;
        this.TramiteGas = new TramiteGas();
        this.TramiteGas.Alta = !this._tengoGas;
        this.TramiteGas.ConexionPrevia = this._conexionGasActivaPasado != undefined ? this._conexionGasActivaPasado : null;
        break;
    }
  }

  private wrapTramites(): void {
    if (this.TramiteLuz != null)
      this.TramiteLuz = new TramiteLuz(this.TramiteLuz);
    if (this.TramiteGas != null)
      this.TramiteGas = new TramiteGas(this.TramiteGas);
  }

  public createFromOperacionDetail(operacion: DetailOperacionEnergiaModel): void{
    Object.assign(this, operacion);
    this.wrapTramites();
    this._tipoPersonaSeleccionada = this.Titular.TipoPersona;
    if (this.TramiteLuz && !this.TramiteGas)
      this._tipoEnergiaSeleccionada = TipoEnergiaSeleccionadaEnum.Luz;
    if (!this.TramiteLuz && this.TramiteGas)
      this._tipoEnergiaSeleccionada = TipoEnergiaSeleccionadaEnum.Gas;
    if (this.TramiteLuz && this.TramiteGas)
      this._tipoEnergiaSeleccionada = TipoEnergiaSeleccionadaEnum.LuzYGas;
    this._tengoLuz = this.TramiteLuz ? !this.TramiteLuz.Alta : undefined;
    this._tengoGas = this.TramiteGas ? !this.TramiteGas.Alta : undefined;
    this._conexionLuzActivaPasado = this.TramiteLuz ? (this.TramiteLuz.ConexionPrevia ? this.TramiteLuz.ConexionPrevia : undefined) : undefined;
    this._conexionGasActivaPasado = this.TramiteGas ? (this.TramiteGas.ConexionPrevia ? this.TramiteGas.ConexionPrevia : undefined) : undefined;

    if(this._tipoEnergiaSeleccionada == TipoEnergiaSeleccionadaEnum.Luz || this._tipoEnergiaSeleccionada == TipoEnergiaSeleccionadaEnum.LuzYGas){
      this.TramiteLuz!.IdOferta = operacion.TramiteLuz!.Oferta.Id;
      this.TramiteLuz!.IdsServicios = operacion.TramiteLuz!.Servicios.map(s => s.Id);
    }
    if(this._tipoEnergiaSeleccionada == TipoEnergiaSeleccionadaEnum.Gas || this._tipoEnergiaSeleccionada == TipoEnergiaSeleccionadaEnum.LuzYGas){
      this.TramiteGas!.IdOferta = operacion.TramiteGas!.Oferta.Id;
      this.TramiteGas!.IdsServicios = operacion.TramiteGas!.Servicios.map(s => s.Id);
    }
  }

  public assignDataFromComparacionEnergia(comparacion: DetailComparacionEnergiaModel): void{
    
    this.IdEmpresaAgentes = comparacion.IdEmpresaAgentes;
    this.Titular.Nombre = comparacion.NombreTitular;
    this.Titular.Apellidos = comparacion.ApellidosTitular;
    this.Titular.Documento = comparacion.DocumentoTitular;
    this.Suministro.Direccion!.CodigoPostal = comparacion.DireccionSuministroCodigoPostal;
    this.Suministro.Direccion!.Provincia = comparacion.DireccionSuministroProvincia;
    this.Suministro.Direccion!.Municipio = comparacion.DireccionSuministroMunicipio;
    this.Suministro.Direccion!.NombreVia = comparacion.DireccionSuministroNombreVia;
    this.Suministro.Direccion!.Numero = comparacion.DireccionSuministroNumero;
    this.Suministro.Direccion!.Piso = comparacion.DireccionSuministroPiso;
    this.Suministro.Direccion!.Puerta = comparacion.DireccionSuministroPuerta;
    this.Facturacion.IBAN = comparacion.Iban;
    
    if (this.TramiteLuz){
        this.TramiteLuz.CUPS = comparacion.CupsLuz;
        this.TramiteLuz.ComercializadoraAnterior = comparacion.ComercializadoraAnteriorLuz;
        this.TramiteLuz.P1 = comparacion.P1;
        this.TramiteLuz.P2 = comparacion.P2;
        this.TramiteLuz.P3 = comparacion.P3;
        this.TramiteLuz.P4 = comparacion.P4;
        this.TramiteLuz.P5 = comparacion.P5;
        this.TramiteLuz.P6 = comparacion.P6;
    }

    if (this.TramiteGas){
      this.TramiteGas.CUPS = comparacion.CupsGas;
      this.TramiteGas.ComercializadoraAnterior = comparacion.ComercializadoraAnteriorGas;
    }
  }

  public assignDataFromInmueble(comparacion: DetailOperacionEnergiaInmuebleModel): void{
    
    this.IdEmpresaAgentes = comparacion.IdEmpresaAgentes;
    this.Suministro.Direccion!.CodigoPostal = comparacion.DireccionSuministroCodigoPostal;
    this.Suministro.Direccion!.Provincia = comparacion.DireccionSuministroProvincia;
    this.Suministro.Direccion!.Municipio = comparacion.DireccionSuministroMunicipio;
    this.Suministro.Direccion!.TipoVia = comparacion.DireccionSuministroTipoVia;
    this.Suministro.Direccion!.NombreVia = comparacion.DireccionSuministroNombreVia;
    this.Suministro.Direccion!.Numero = comparacion.DireccionSuministroNumero;
    this.Suministro.Direccion!.Escalera = comparacion.DireccionSuministroEscalera;
    this.Suministro.Direccion!.Piso = comparacion.DireccionSuministroPiso;
    this.Suministro.Direccion!.Puerta = comparacion.DireccionSuministroPuerta;
    
    if (this.TramiteLuz){
        this.TramiteLuz.CUPS = comparacion.CupsLuz;
    }

    if (this.TramiteGas){
      this.TramiteGas.CUPS = comparacion.CupsGas;
    }
  }

  private resetTramites(): void {
    this.TramiteLuz = null;
    this.TramiteGas = null;
  }

  public addDocumento(documento: DocumentosModel): void {
    this.Documentos.push(documento);
  }

  public removeDocumento(documento: EstructuraDocumentalOperacionEnergiaModel): void {
    this.Documentos = this.Documentos.filter(doc => doc.Tipo != documento.TipoDocumento)
  }
}

export enum TipoCambioSuministroEnum {
  MismaCompania = "misma_compania",
  MismoGrupoMercado = "mismo_grupo_mercado",
  CambioComercializadora = "cambio_comercializadora",
}

export class TramiteLuz implements TramiteLuzModel {
  public CUPS: string | null = null;
  public TarifaAcceso: string | null = null;
  public IdOferta: string = '';
  public IdsServicios: Array<string> = [];
  public Alta: boolean = false;
  public ConexionPrevia: boolean | null = null;
  public IdTension: string | null = null;
  public Tension: string | null = null;
  public P1: number | null = null;
  public P2: number | null = null;
  public P3: number | null = null;
  public P4: number | null = null;
  public P5: number | null = null;
  public P6: number | null = null;
  public P1_Nueva: number | null = null;
  public P2_Nueva: number | null = null;
  public P3_Nueva: number | null = null;
  public P4_Nueva: number | null = null;
  public P5_Nueva: number | null = null;
  public P6_Nueva: number | null = null;
  public CambioPotenciaContratada: boolean = false;
  public DistintaComercializadoraMismoGrupo: boolean | null = null;
  public ComercializadoraAnterior: string | null = null;
  public Autoconsumo : TipoAutoconsumoEnum | null = null;
  public IdsDescuentos: Array<string> = [];
  public Consumo: number | null = null;

  private _tipoCambioSuministro: TipoCambioSuministroEnum | null = null;

  get TipoCambioSuministro(): TipoCambioSuministroEnum | null {
    return this._tipoCambioSuministro;
  }

  set TipoCambioSuministro(value: TipoCambioSuministroEnum | null) {
    this._tipoCambioSuministro = value;
    if (value === TipoCambioSuministroEnum.MismoGrupoMercado) {
      this.ComercializadoraAnterior = null;
      this.DistintaComercializadoraMismoGrupo = true;
    } else if (value === TipoCambioSuministroEnum.CambioComercializadora) {
      this.DistintaComercializadoraMismoGrupo = false;
    } else if (value === TipoCambioSuministroEnum.MismaCompania) {
      this.ComercializadoraAnterior = null;
      this.DistintaComercializadoraMismoGrupo = false;
    } else {
      this.DistintaComercializadoraMismoGrupo = null;
    }
  }

  constructor(data?: Partial<TramiteLuz>) {
    Object.assign(this, data);
    if (this._tipoCambioSuministro == null) {
      if (this.DistintaComercializadoraMismoGrupo === true) {
        this._tipoCambioSuministro = TipoCambioSuministroEnum.MismoGrupoMercado;
      } else if (this.ComercializadoraAnterior != null && this.ComercializadoraAnterior !== "") {
        this._tipoCambioSuministro = TipoCambioSuministroEnum.CambioComercializadora;
      } else if (this.DistintaComercializadoraMismoGrupo === false) {
        this._tipoCambioSuministro = TipoCambioSuministroEnum.MismaCompania;
      }
    }
  }
}


export class TramiteGas implements TramiteGasModel {
  public CUPS: string | null = null;
  public TarifaAcceso: string | null = null;
  public IdOferta: string = '';
  public IdsServicios: Array<string> = [];
  public Alta: boolean = false;
  public ConexionPrevia: boolean | null = null;
  public DistintaComercializadoraMismoGrupo: boolean | null = null;
  public ComercializadoraAnterior: string | null = null;
  public IdsDescuentos: Array<string> = [];
  public Consumo: number | null = null;

  private _tipoCambioSuministro: TipoCambioSuministroEnum | null = null;

  get TipoCambioSuministro(): TipoCambioSuministroEnum | null {
    return this._tipoCambioSuministro;
  }

  set TipoCambioSuministro(value: TipoCambioSuministroEnum | null) {
    this._tipoCambioSuministro = value;
    if (value === TipoCambioSuministroEnum.MismoGrupoMercado) {
      this.ComercializadoraAnterior = null;
      this.DistintaComercializadoraMismoGrupo = true;
    } else if (value === TipoCambioSuministroEnum.CambioComercializadora) {
      this.DistintaComercializadoraMismoGrupo = false;
    } else if (value === TipoCambioSuministroEnum.MismaCompania) {
      this.ComercializadoraAnterior = null;
      this.DistintaComercializadoraMismoGrupo = false;
    } else {
      this.DistintaComercializadoraMismoGrupo = null;
    }
  }

  constructor(data?: Partial<TramiteGas>) {
    Object.assign(this, data);
    if (this._tipoCambioSuministro == null) {
      if (this.DistintaComercializadoraMismoGrupo === true) {
        this._tipoCambioSuministro = TipoCambioSuministroEnum.MismoGrupoMercado;
      } else if (this.ComercializadoraAnterior != null && this.ComercializadoraAnterior !== "") {
        this._tipoCambioSuministro = TipoCambioSuministroEnum.CambioComercializadora;
      } else if (this.DistintaComercializadoraMismoGrupo === false) {
        this._tipoCambioSuministro = TipoCambioSuministroEnum.MismaCompania;
      }
    }
  }
}